<template>
  <div class="text-button" @click="$emit('click')">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'
.text-button
  font-size $small-font-size
  color #555555
  text-align center
  margin 0 auto
  text-align center

</style>




// WEBPACK FOOTER //
// text-button.vue?7be6b9ca